<template>
    <div id="bars-layered-chart" class="mt-5"></div>
</template>

<script>
  import * as d3 from "d3";
  const LEGEND_ITEM_HEIGHT = 35;

  export default {
    name: "BarsLayeredChart",
    props: {
      groupKey: String,
      data: Array,
    },
    data: () => ({
      width: 1000,
      height: 500,
      margin: {top: 10, right: 10, bottom: 20, left: 50},
      keys: [],
      legendHeight: 0,
      color: d3.scaleOrdinal().range(["#98abc5", "#8a89a6", "#7b6888", "#6b486b", "#a05d56", "#d0743c", "#ff8c00"])
    }),
    mounted() {
      this.renderChart();
    },
    beforeMount() {
      this.updateKeys();
    },
    methods: {
      updateKeys() {
        this.keys = [];

        Object.keys(this.data[0]).map((key) => {
          if (key !== this.groupKey) {
            this.keys.push(key);
          }
        });

        this.legendHeight = this.keys.length * LEGEND_ITEM_HEIGHT;
        this.height += this.legendHeight;
      },
      getLegend() {
        const legend = svgNode => {
          const g = svgNode
            .attr("transform", `translate(${this.width},0)`)
            .attr("text-anchor", "end")
            .attr("font-family", "sans-serif")
            .attr("font-size", 10)
            .selectAll("g")
            .data(this.color.domain().slice().reverse())
            .join("g")
            .attr("transform", (d, i) => `translate(0,${i * 40})`);

          g.append("rect")
            .attr("x", -19)
            .attr("width", 19)
            .attr("height", 19)
            .attr("fill", this.color);

          g.append("text")
            .attr("x", -44)
            .attr("y", 10.5)
            .attr("dy", "0.35em")
            .text(d => d);
        };

        return legend;
      },
      renderChart() {
        const yAxis = g => g
          .attr("transform", `translate(${this.margin.left - 30},0)`)
          .call(d3.axisLeft(y).ticks(null, "s"))
          .call(g => g.select(".domain").remove())
          .call(g => g.select(".tick:last-of-type text").clone()
            .attr("x", 3)
            .attr("text-anchor", "start")
            .attr("font-weight", "bold")
            .text(''));

        const xAxis = g => g
          .attr("transform", `translate(0,${this.height - this.margin.bottom})`)
          .call(d3.axisBottom(x0).tickSizeOuter(0))
          .call(g => g.select(".domain").remove());

        const y = d3.scaleLinear()
          .domain([0, d3.max(this.data, d => d3.max(this.keys, key => d[key]))]).nice()
          .rangeRound([this.height - this.margin.bottom, this.margin.top + this.legendHeight]);

        const x0 = d3.scaleBand()
          .domain(this.data.map(d => d[this.groupKey]))
          .rangeRound([this.margin.left, this.width - this.margin.right])
          .paddingInner(0.5);

        const x1 = d3.scaleBand()
          .domain(this.keys)
          .rangeRound([10, x0.bandwidth()])
          .padding(-0.1);

        const svg = d3.select('#bars-layered-chart').append('svg')
          .attr("id", "svg")
          .attr('height', this.height)
          .attr('width', this.width);

        svg.append("g")
          .selectAll("g")
          .data(this.data)
          .join("g")
          .attr("transform", d => `translate(${x0(d[this.groupKey])},0)`)
          .selectAll("rect")
          .data(d => this.keys.map(key => ({key, value: d[key]})))
          .join("rect")
          .attr("x", d => x1(d.key))
          .attr("y", d => y(d.value))
          .attr("width", x1.bandwidth())
          .attr("height", d => y(0) - y(d.value))
          .attr("fill", d => this.color(d.key));

        svg.append("g")
          .call(xAxis);

        svg.append("g")
          .call(yAxis);

        svg.append("g")
          .call(this.getLegend());

        return svg.node();
      }
    }
  }
</script>
